import React from "react";
import { useAuth } from "@/contexts/AuthContext";

export default function Profile() {
  const { user } = useAuth();

  const fullName = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .map(n => n.charAt(0).toUpperCase() + n.slice(1))
    .join(" ") || "User";

  return (
    <div className="pt-[30px] pb-24 md:pb-[30px] px-4 md:px-[60px] bg-page-bg min-h-full flex flex-col gap-1.5">
      <h1 className="text-[32px] font-medium leading-tight text-page-title">User Profile</h1>
      <p className="text-sm font-normal text-page-muted">{fullName}{user?.email ? ` — ${user.email}` : ""}</p>
    </div>
  );
}
